import React from 'react';
import { FormRow } from '../form/FormRow';
import { Label } from '../form/Label';
import { FormField } from '../form/FormField';
import { Input } from '../form/Input';
import { useDispatch, useSelector } from 'react-redux';
import { selectDoctor } from '../../store/registration/registration.selector';
import { registrationActions } from '../../store/registration/registration.reducer';
import { selectUser } from '../../store/auth/auth.selector';
import { RequestType } from '../../model/enums/RequestType';
import { EmailFormField } from '../form/EmailFormField';
import { PhoneFormField } from '../form/PhoneFormField';

type DoctorInformationProps = {
  onEmailValid?: ((valid: boolean) => void) | undefined,
  onPhoneValid?: ((valid: boolean) => void) | undefined
}

export const DoctorInformation = (props: DoctorInformationProps) => {
    const user = useSelector(selectUser);
    const doctor = useSelector(selectDoctor);
    const dispatch = useDispatch();

    return (
      <>
        <form onSubmit={(e) => e.preventDefault()}>
          <FormRow>
            <FormField>
              <Label>Titul před jménem:</Label>
              <Input onChange={e => dispatch(registrationActions.setDoctor({ titleBefore: e.target.value }))}
                     value={doctor.titleBefore}
                     name='titleBefore' />
            </FormField>
            <FormField>
              <Label required={user?.requestType === RequestType.DoctorRegistration}>Jméno:</Label>
              <Input onChange={e => dispatch(registrationActions.setDoctor({ firstName: e.target.value }))}
                     value={doctor.firstName}
                     name='firstName' />
            </FormField>
          </FormRow>

          <FormRow>
            <FormField>
              <Label required={user?.requestType === RequestType.DoctorRegistration}>Příjmení:</Label>
              <Input onChange={e => dispatch(registrationActions.setDoctor({ lastName: e.target.value }))}
                     value={doctor.lastName}
                     name='lastName' />
            </FormField>
            <FormField>
              <Label>Titul za jménem:</Label>
              <Input onChange={e => dispatch(registrationActions.setDoctor({ titleAfter: e.target.value }))}
                     value={doctor.titleAfter}
                     name='titleAfter' />
            </FormField>
          </FormRow>

          <FormRow>
            <EmailFormField required={false}
                            onChangeValid={props.onEmailValid}
                            onChangeValue={(email: string) => dispatch(registrationActions.setDoctor({ email: email }))} />

            <PhoneFormField required={user?.requestType === RequestType.DoctorRegistration}
                            disabled={user?.requestType === RequestType.DoctorRegistration}
                            initialValue={doctor.phone}
                            onChangeValid={props.onPhoneValid}
                            onChangeValue={(phone: string) => dispatch(registrationActions.setPatient({ phone: phone }))}  />
          </FormRow>
          <FormRow>

          </FormRow>
          <FormField>
            <Label>Poznámka:</Label>
            <Input multiline={true}
                   rows={5}
                   onChange={e => dispatch(registrationActions.setDoctor({ note: e.target.value }))}
                   value={doctor.note}
                   name='note'
                   placeholder='Např. název nebo adresa ordinace, pracovní hodiny...' />
          </FormField>
        </form>
      </>
    );
  }
;

DoctorInformation.defaultProps = {
  validFields: {
    phone: false,
    email: false
  }
};
